// modules/TimeRangeField.jsx
import React from "react";
import { Box, TextField, Grid, Typography } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const TimeRangeField = ({ module, value, isEditable, fieldKey, onChange }) => {
  const timeRange = value || { startTime: null, endTime: null };
  const startTimeObj = timeRange.startTime ? dayjs(timeRange.startTime) : null;
  const endTimeObj = timeRange.endTime ? dayjs(timeRange.endTime) : null;

  return (
    <Box marginY={2}>
      <Typography variant="h6">{module.label}</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TimePicker
            label="Start Time"
            value={startTimeObj}
            onChange={(newValue) =>
              onChange(
                fieldKey,
                "startTime",
                newValue ? newValue.toISOString() : null,
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                required={module.required}
                InputProps={{ readOnly: !isEditable }}
              />
            )}
            disabled={!isEditable}
          />
        </Grid>
        <Grid item xs={6}>
          <TimePicker
            label="End Time"
            value={endTimeObj}
            onChange={(newValue) =>
              onChange(
                fieldKey,
                "endTime",
                newValue ? newValue.toISOString() : null,
              )
            }
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                required={module.required}
                InputProps={{ readOnly: !isEditable }}
              />
            )}
            disabled={!isEditable}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TimeRangeField;
